'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./PlanScorecardRedirect.css');

var PlanScorecardRedirect = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardRedirect, _Component);

  function PlanScorecardRedirect() {
    (0, _classCallCheck3.default)(this, PlanScorecardRedirect);
    return (0, _possibleConstructorReturn3.default)(this, (PlanScorecardRedirect.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardRedirect)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlanScorecardRedirect, [{
    key: 'render',
    value: function render() {
      var title = 'Apple';
      var description = 'See how Apple\'s is rated on environmental and social sustainability issues.';
      var url = _config2.default.domain + _config2.default.routes.plans + '/apple';

      this.context.router.push(_config2.default.routes.plans + '/apple?li=1');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
      );
    }
  }]);
  return PlanScorecardRedirect;
}(_react.Component), _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardRedirect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PlanScorecardRedirect/PlanScorecardRedirect.js
// module id = 1495
// module chunks = 0